var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertErrorWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 0C0.716344 0 0 0.716345 0 1.6V14.4C0 15.2837 0.716345 16 1.6 16H14.4C15.2837 16 16 15.2837 16 14.4V1.6C16 0.716344 15.2837 0 14.4 0H1.6ZM6.66667 2.93333C6.66667 2.63878 6.90545 2.4 7.2 2.4H8.8C9.09455 2.4 9.33333 2.63878 9.33333 2.93333V8.8C9.33333 9.09455 9.09455 9.33333 8.8 9.33333H7.2C6.90545 9.33333 6.66667 9.09455 6.66667 8.8V2.93333ZM6.66667 10.9333C6.66667 10.6388 6.90545 10.4 7.2 10.4H8.8C9.09455 10.4 9.33333 10.6388 9.33333 10.9333V12.5333C9.33333 12.8279 9.09455 13.0667 8.8 13.0667H7.2C6.90545 13.0667 6.66667 12.8279 6.66667 12.5333V10.9333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertErrorWhite);
export default __webpack_public_path__ + "static/media/ico_alert_error_white.22941096.svg";
export { ForwardRef as ReactComponent };